import { useStoreSettings } from "@/hooks/useStoreSettings";

/**
 * Shows the brand logo image, falling back to stylised text if no logo is set.
 *
 * @param {"sm"|"md"|"lg"|"xl"} size         - Logo height   (sm=24 / md=32 / lg=40 / xl=48)
 * @param {"dark"|"light"}      textVariant  - Fallback text colour: dark=orange+slate, light=white
 * @param {string}              className    - Extra classes applied to the img or span
 */
export default function BrandLogo({ size = "md", textVariant = "dark", className = "" }) {
  const settings = useStoreSettings();
  const logoUrl = settings?.logo_url;

  const heights   = { sm: "h-6", md: "h-8", lg: "h-10", xl: "h-12" };
  const textSizes = { sm: "text-sm", md: "text-base", lg: "text-xl", xl: "text-2xl" };

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={settings?.store_name || "IMPORTREND"}
        className={`${heights[size]} w-auto object-contain ${className}`}
        loading="eager"
      />
    );
  }

  // Text fallback
  if (textVariant === "light") {
    return (
      <span className={`font-black tracking-tight text-white ${textSizes[size]} ${className}`}>
        IMPORTREND
      </span>
    );
  }

  return (
    <span className={`font-black tracking-tight ${textSizes[size]} ${className}`}>
      <span className="text-orange-500">IMPORT</span>
      <span className="text-slate-800">REND</span>
    </span>
  );
}
